"use client";
import type { IconTypes } from "@/components/icons/types";
import { Children, ReactNode, isValidElement, type JSX } from "react";
import IndustryHighlights from ".";

type ShortCodeIndustryHighlightsProps = {
  "tag-text"?: string;
  "tag-icon"?: string;
  title?: string;
  subject?: string;
  "tasks-title"?: string;
  "disclaimer-text"?: string;
  "disclaimer-link"?: string;
  "disclaimer-text-after": string;
  children?: JSX.Element;
  "search-query"?: string;
  "number-of-hits"?: number;
};

export function ShortCodeIndustryHighlights({
  "tag-text": tagText,
  "tag-icon": tagIcon,
  title,
  subject,
  "tasks-title": tasksTitle,
  "disclaimer-text": disclaimerText,
  "disclaimer-link": disclaimerLink,
  "disclaimer-text-after": disclaimerTextAfter,
  children,
  "search-query": searchQuery,
  "number-of-hits": numberOfHits,
}: ShortCodeIndustryHighlightsProps) {
  const tasks: string[] = [];
  const stats: Array<{
    label: string;
    value: string;
    icon: IconTypes;
  }> = [];

  Children.toArray(children).forEach((child: ReactNode) => {
    if (isValidElement(child)) {
      const element = child as React.ReactElement<{
        task?: string;
        label?: string;
        value?: string;
        icon?: IconTypes;
        skill?: string;
      }>;

      // Handle stat items
      if (element.props.label && element.props.value && element.props.icon) {
        stats.push({
          label: element.props.label,
          value: element.props.value,
          icon: element.props.icon,
        });
      }

      // Handle task items
      if (element.props.task) {
        tasks.push(element.props.task);
      }
    }
  });

  return (
    <IndustryHighlights
      tagText={tagText}
      tagIcon={tagIcon as IconTypes | undefined}
      title={title}
      subject={subject}
      tasksTitle={tasksTitle}
      tasks={tasks.length > 0 ? tasks : undefined}
      stats={stats.length > 0 ? stats : undefined}
      disclaimerText={disclaimerText}
      disclaimerLink={disclaimerLink}
      disclaimerTextAfter={disclaimerTextAfter}
      searchQuery={searchQuery}
      numberOfHits={numberOfHits}
    />
  );
}

// These are placeholder components that serve as data carriers for the parent component
// They don't render anything - the parent extracts their props
export function ShortCodeIndustryHighlightsTask() {
  return null;
}

export function ShortCodeIndustryHighlightsStat() {
  return null;
}
